import { render, staticRenderFns } from "./EnrollmentSetup.vue?vue&type=template&id=4e792a84&scoped=true&"
import script from "./EnrollmentSetup.vue?vue&type=script&lang=js&"
export * from "./EnrollmentSetup.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./EnrollmentSetup.vue?vue&type=style&index=1&id=4e792a84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e792a84",
  null
  
)

export default component.exports